/**
 * @desc 查询仓库下交易主体
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.warehouse.warehouseCompany.Params, options?: any) {
  return updateResponse(
    http(URL + `/warehouse/warehouseCompany`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
